import {useEffect} from 'react';
import {useLastAccessTime} from '../auth/hooks/useLastAccessTime';
import {WithSessionExpiration} from '../auth/WithSessionExpiration';
import {L10nProvider} from '../i18n/L10nProvider';
import {ComponentWithoutChildren} from '../react/types';
import {CurrentThemeProvider} from '../theme/ThemeProvider';
import {WithCurrentUser} from '../users/WithCurrentUser';
import {PrivateOutlet} from './PrivateOutlet';

export const PrivateAppOutlet: ComponentWithoutChildren = () => {
  // Update the last access time in local storage when private app route is rendered
  const [, setLastAccessTime] = useLastAccessTime();
  useEffect(() => {
    setLastAccessTime(new Date());
  }, [setLastAccessTime]);

  return (
    <WithCurrentUser>
      <L10nProvider>
        <CurrentThemeProvider>
          <WithSessionExpiration>
            <PrivateOutlet />
          </WithSessionExpiration>
        </CurrentThemeProvider>
      </L10nProvider>
    </WithCurrentUser>
  );
};

export default PrivateAppOutlet; // Default export required for react lazy
